import {
  ProfileCollectionModes,
  ProfileWatchlistParamTypeEnum,
  ProfileWatchlistParamUnitEnum,
} from '../features/ng-redux/profiles/profiles.models';
import { CONSTANTS } from '../localizations/dictionary';

export interface IWatchlistUiParamModelField {
  type: string;
  //comparisonOperator: string;
  name: string;
  thresholdUnit: string | number;
  thresholdValue: string;
  enabled: boolean;
}

export interface ICollectionModeOption {
  key: ProfileCollectionModes;
  displayText: string;
}

export interface IAnalyticsProifleDataSource {
  dataSourceId: string;
  groups: string[];
}

export class AnalyticsProfilesParamUiModel {
  static getCollectionModeOptions(): ICollectionModeOption[] {
    return [
      {
        key: 'standard',
        displayText: 'Analysis_Profile_Form_Collection_Mode_Standard',
      },
      {
        key: 'battery-optimized',
        displayText: 'Analysis_Profile_Form_Optimized_Battery',
      },
      {
        key: 'accuracy-optimized',
        displayText: 'Analysis_Profile_Form_Optimized_Accuracy',
      },
    ];
  }

  static formatAMPM(hours: number, minutes: number) {
    const sec = '';
    const date = new Date();
    //let hours = date.getHours();
    //let minutes: number | string = date.getMinutes();
    // const seconds: number | string = date.getSeconds();

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;
    const strTime = hours + ':' + minutesStr + sec + ' ' + ampm;
    return strTime;
  }
}

export class UnitDropdownOption {
  index: number;
  value: string;
  display: string | number;

  constructor(_index: number, _value: any, _display: any) {
    this.index = _index;
    this.value = _value;
    this.display = _display;
  }
}

export const DATA_UPLOAD_OPTIONS = [
  {
    key: 'wifi+ethernet',
    displayText: 'Analysis_Profile_Form_WiFi_Ethernet',
  },
  {
    key: 'wifi+ethernet+cellular',
    displayText: 'Analysis_Profile_Form_WiFi_Ethernet_Cellular',
  },
  {
    key: 'wifi+ethernet+cellular+cellular-roaming',
    displayText: 'Analysis_Profile_Form_WiFi_Ethernet_Cellular_Roaming',
  },
];

export const COLLECTION_MODE_OPTIONS = [
  {
    key: 'standard',
    displayText: 'Analysis_Profile_Form_Collection_Mode_Standard',
  },
  {
    key: 'battery-optimized',
    displayText: 'Analysis_Profile_Form_Optimized_Battery',
  },
  {
    key: 'accuracy-optimized',
    displayText: 'Analysis_Profile_Form_Optimized_Accuracy',
  },
];

export const DATA_DELIVERY_INTERVALS = [
  {
    key: 24,
    displayText: 'Analysis_Profile_Form_24_Hours',
  },
  {
    key: 12,
    displayText: 'Analysis_Profile_Form_12_Hours',
  },
  {
    key: 6,
    displayText: 'Analysis_Profile_Form_6_Hours',
  },
  {
    key: 4,
    displayText: 'Analysis_Profile_Form_4_Hours',
  },
  {
    key: 3,
    displayText: 'Analysis_Profile_Form_3_Hours',
  },
];

export const DATA_DELIVERY_WINDOW_SIZES = [
  {
    key: 6,
    displayText: 'Analysis_Profile_Form_6_Hours',
  },
  {
    key: 5,
    displayText: 'Analysis_Profile_Form_5_Hours',
  },
  {
    key: 4,
    displayText: 'Analysis_Profile_Form_4_Hours',
  },
  {
    key: 2,
    displayText: 'Analysis_Profile_Form_2_Hours',
  },
  {
    key: 1,
    displayText: 'Analysis_Profile_Form_1_Hours',
  },
];

export const TIME_UNIT_DROPDOWN_VALUES: UnitDropdownOption[] = [
  // {
  //   index: 1,
  //   value: ProfileWatchlistParamUnitEnum.HOURS.value,
  //   display: ProfileWatchlistParamUnitEnum.HOURS.display,
  // },
  {
    index: 1,
    value: ProfileWatchlistParamUnitEnum.DAY.value,
    display: ProfileWatchlistParamUnitEnum.DAY.display,
  },
];

export const DATA_UNIT_DROPDOWN_VALUES: UnitDropdownOption[] = [
  {
    index: 1,
    value: ProfileWatchlistParamUnitEnum.MEGABYTE.value,
    display: ProfileWatchlistParamUnitEnum.MEGABYTE.display,
  },
  {
    index: 2,
    value: ProfileWatchlistParamUnitEnum.GIGABYTE.value,
    display: ProfileWatchlistParamUnitEnum.GIGABYTE.display,
  },
];

export const PERCENT_UNIT_DROPDOWN_VALUES: UnitDropdownOption[] = [
  {
    index: 1,
    value: ProfileWatchlistParamUnitEnum.PERCENTAGE.value,
    display: ProfileWatchlistParamUnitEnum.PERCENTAGE.display,
  },
];

export const ABSOLUTE_UNIT_DROPDOWN_VALUES: UnitDropdownOption[] = [
  {
    index: 1,
    value: ProfileWatchlistParamUnitEnum.ABSOLUTE.value,
    display: ProfileWatchlistParamUnitEnum.ABSOLUTE.display,
  },
];
